import IndicatorsSection from './IndicatorsSection';
export default IndicatorsSection;
